import Network from 'lib/api/network';

export default {
  namespaced: true,

  state() {
    return {
      currentPage: 0,
      rows: [],
      totalPages: 0,
      loading: true,
    };
  },

  getters: {
    perPage() { return 10; },

    rows(state) { return state.rows; },
    numPages(state) { return state.totalPages || 1; },
    loading(state) { return state.loading; },
  },

  mutations: {
    setCurrentPage(state, pageNum) {
      state.currentPage = pageNum;
    },
    setRows(state, rows) {
      state.rows = rows || [];
    },
    setTotalPages(state, totalPages) {
      state.totalPages = totalPages || 1;
    },
    setLoading(state, val) {
      state.loading = !!val;
    },
  },

  actions: {
    async fetchPage({ state, getters, commit }) {
      commit('setLoading', true);
      try {
        const pageParam = state.currentPage + 1; // Kaminari is 1-indexed
        const per = getters.perPage;
        const res = await fetch(`/users/channels.json?page=${pageParam}&per=${per}`, { credentials: 'same-origin' });
        const data = await res.json();
        commit('setRows', data.rows);
        commit('setTotalPages', data.total_pages);
      } finally {
        commit('setLoading', false);
      }
    },

    async changePage({ commit, dispatch }, { pageNum }) {
      commit('setCurrentPage', pageNum);
      await dispatch('fetchPage');
    },

    async updateProgramStatus({ state, dispatch, rootState, commit }, { programId, status, daysToSnooze }) {
      const row = (state.rows || []).find((r) => r.program_id === programId);
      if (!row) return;

      commit('setLoading', true);

      try {
        const payload = {
          user_uids: JSON.stringify([rootState.currentUser.uid]),
          status,
          coffee_configuration_id: programId,
        };
        if (status === 'snoozed' && daysToSnooze != null) {
          payload.days_to_snooze = parseInt(daysToSnooze, 10);
        }

        await new Promise((resolve, reject) => {
          Network.post(
            `/coffee/${programId}/update_users_status`,
            payload,
            {
              success: resolve,
              error: reject,
            },
          );
        });
        await dispatch('fetchPage');
      } catch (e) {
        commit('setLoading', false);
      }
    },
  },
};
